import React from "react";
import AutoComplete1 from "../../Utils/Select";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
const bestTimeToCall = [
  { label: "Morning", value: "M" },
  { label: "Afternoon", value: "A" },
  { label: "Evening", value: "E" },
];
const contactPreference = [
  { label: "Home Phone", value: "H" },
  { label: "Cell Phone", value: "C" },
  { label: "Email Address", value: "E" },
];
const Demographics = (props) => {
  return (
    <div
      id="demographics"
      class={
        props?.disable === true
          ? "tab-pane active disable-form"
          : "tab-pane active"
      }
    >
      <div class="panel-body container">
        {/* //  prospectdemo"> */}
        <div class="form-panel2">
          <div class="row ">
            {/* <div class="col-md-12"> */}
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label class="labelprospect" for="demographics_primary_address1">
                Primary Address 1<span class="mandatory-field">*</span>
              </label>
              <br />
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="text"
                class={
                  props.data.primaryAddress1 === ""
                    ? "error-inputprospect  w-236px"
                    : "form-control1  w-236px"
                }
                id="demographics_primary_address1"
                name="primaryAddress1"
                value={props.data.primaryAddress1}
                maxLength="50"
                onChange={props.handleChange}
              />
              {/* <TextField   name="primaryAddress1"
                             value={props.data.primaryAddress1}
                             onChange={props.handleChange}                                 
                            error={
                              //props.demographicsSave?
                              props.data?.primaryAddress1 === ""}
                            size="small"
                            className="prospectwidth9"
                            label="Primary Address 1*" variant="outlined" /> */}
            </span>
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label class="labelprospect" for="demographics_primary_address2">
                Primary Address 2{/* <span class="mandatory-field">*</span>  */}
              </label>
              <br />
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="text"
                // class={
                //   props.data.primaryAddress2 === ""
                //     ? "error-inputprospect"
                class={"form-control1  w-236px"}
                id="demographics_primary_address2"
                name="primaryAddress2"
                value={props.data.primaryAddress2}
                maxLength="50"
                onChange={props.handleChange}
              />
              {/* <TextField  name="primaryAddress2"
                            value={props.data.primaryAddress2}
                            onChange={props.handleChange}                                                         
                            size="small"
                            className="prospectwidth9"
                            label="Primary Address 2" variant="outlined" /> */}
            </span>
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label class="labelprospect" for="demographics_zip">
                Zip
                <span class="mandatory-field">*</span>
              </label>
              <br />
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="text"
                class={
                  props.validZip === true
                    ? props.data?.zip === "" || props.data?.zip?.length < 5
                      ? "error-inputprospect  w-236px"
                      : "form-control1  w-236px"
                    : "error-inputprospect"
                }
                id="demographics_zip"
                name="zip"
                value={props.data.zip}
                onChange={props.handleChange}
                maxLength="5"
              />
              {/* <TextField  name="zip"
                            value={props.data.zip}
                            onChange={props.handleChange}
                            // maxLength="5"                                
                            error={
                              // props.demographicsSave?
                              props.validZip===true?(props.data?.zip === "" ||props.data?.zip?.length<5)?true:false:true}
                            size="small"
                            inputProps={{ maxLength:5}} 
                            className="prospectwidth9"
                            label="Zip*" variant="outlined" /> */}
            </span>

            {/* </div> */}
          </div>
          <div class="row ">
            {/* <div class="col-md-12"> */}
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4">
              {props?.ZipCodes && props.ZipCodes.length > 1 ? (
                <div>
                  <label class="labelprospect" for="demographics_county">
                    County
                    <span class="mandatory-field">*</span>
                  </label>
                  <br />
                  {/* <select
                      id="county"
                      name="county"
                      value={props.data.county}
                      onChange={props.handleChange}
                      class={
                        //props.demographicsSave?
                        props.data.county === ""
                          ? "error-inputdashboard"
                          : "form-control1dashboard"
                         // :"form-control1dashboard"
                      }
                    >
                      <option value="">Select a County</option>
                      {props.ZipCodes.map((county) => (
                        <option value={county.countyName}>
                          {county.countyName}
                        </option>
                      ))}
                    </select> */}
                  <AutoComplete1
                    dashboard="prospect"
                    height="7px !important"
                    width="236px"
                    handleChange={props.handleOtherDropdown("county")}
                    options={props.ZipCodes.map(({ countyName: value }) => ({
                      value,
                      label: value,
                    }))}
                    value={
                      props?.ZipCodes.map(({ countyName: value }) => ({
                        value,
                        label: value,
                      })).filter((data1) => data1.value === props.data.county)
                        .length !== 0
                        ? props?.ZipCodes.map(({ countyName: value }) => ({
                            value,
                            label: value,
                          })).filter(
                            (data1) => data1.value === props.data.county
                          )[0]
                        : { label: "select", value: "" }
                    }
                    defaultValue={{ label: "select", value: "" }}
                    name="county"
                  />
                </div>
              ) : (
                <div>
                  <label class="labelprospect" for="demographics_county">
                    County
                    <span class="mandatory-field">*</span>
                  </label>
                  <br />
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="text"
                    style={{ cursor: "not-allowed" }}
                    class={
                      props.data.county === ""
                        ? "error-inputprospect  w-236px"
                        : "form-control1  w-236px"
                    }
                    name="county"
                    id="county"
                    value={props.data.county}
                    disabled
                  />
                </div>
                // <TextField  name="county"
                // value={
                //      props.data.county
                //     }
                //     disabled
                // size="small"
                // error={
                //  // props.demographicsSave?
                //   props.data?.county === ""}
                //   className="prospectwidth9"
                // label="County" variant="outlined" />
              )}
            </span>
            <span class="col-lg-4 col-md-12 col-sm-12 mb-4">
              <label class="labelprospect" for="demographics_city">
                City
                <span class="mandatory-field">*</span>
              </label>
              <br />

              {props?.filteredCity && props.filteredCity?.length > 1 ? (
                <select
                  id="demographics_city"
                  name="city"
                  value={props.data.city}
                  onChange={props.handleChange}
                  class={
                    props.data.city === ""
                      ? "error-inputprospect w-236px"
                      : "form-control1 w-236px"
                  }
                >
                  {props.filteredCity.map((city) => (
                    <option value={city.cityName?.trim()}>
                      {city.cityName}
                    </option>
                  ))}
                </select>
              ) : ( 
                <input
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                  type="text"
                  class={
                    props.data.city === ""
                      ? "error-inputprospect w-236px"
                      : "form-control1 w-236px"
                  }
                  id="demographics_city"
                  name="city"
                  value={props.data.city}
                  onChange={props.handleChange}
                  disabled
                />
              )}
            </span>
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4">
              <label class="labelprospect" for="demographics_state">
                State
                <span class="mandatory-field">*</span>
              </label>
              <br />
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="text"
                class={
                  props.data.state === ""
                    ? "error-inputprospect w-236px"
                    : "form-control1  w-236px"
                }
                id="demographics_state"
                name="state"
                value={props.data.state}
                disabled
                onChange={props.handleChange}
              />
              {/* <TextField  name="state"
                            disabled 
                            value={props.data.state}
                            onChange={props.handleChange}                                
                            error={
                              //props.prospectSaveFlag?
                              (props.data.state === "")}
                            size="small"
                            className="prospectwidth9"
                            label="State*" variant="outlined" /> */}
            </span>
            {/* zipold */}

            {/* </div> */}
          </div>
          <div class="row ">
            {/* <div class="col-md-12"> */}
            {/* oldcounty */}
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label class="labelprospect" for="demographics_zip4">
                Zip + 4
              </label>
              <br />
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="text"
                class={"form-control1  w-236px"}
                id="demographics_zip4"
                name="zipPlus4"
                value={props.data.zipPlus4}
                onChange={props.handleChange}
                maxLength="4"
              />
              {/* <TextField  name="zipPlus4"
                            value={props.data.zipPlus4}
                           onChange={props.handleChange}
                            // maxLength="5"                                                        
                            size="small"
                            inputProps={{maxLength:4}} 
                            className="prospectwidth9"
                            label="Zip + 4" variant="outlined" /> */}
            </span>
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4">
              <label
                class="labelprospect"
                for="demographics_contact_preferrence"
              >
                Contact preference
              </label>
              <br />

              <AutoComplete1
                //label="Contact preference"
                //  show={false}
                dashboard="prospect"
                height="7px !important"
                width="236px"
                handleChange={props.handleOtherDropdown("contactPreference")}
                options={contactPreference}
                value={
                  props.data?.contactPreference &&
                  contactPreference.filter(
                    (data1) => data1.value === props.data.contactPreference
                  ).length !== 0
                    ? props.data?.contactPreference &&
                      contactPreference.filter(
                        (data1) => data1.value === props.data.contactPreference
                      )[0]
                    : { label: "", value: "" }
                }
                // defaultValue={
                // props.data?.contactPreference &&
                // contactPreference.filter(
                //   (data1) => data1.value === props.data.contactPreference
                // )[0]===(undefined || "")
                // ?
                // { label: "select", value: "" }
                // :
                // props.data?.contactPreference &&
                // contactPreference.filter(
                //   (data1) => data1.value === props.data.contactPreference
                // )[0]
                // }
                //value={props.data.preferredLang}
                name="contactPreference"
                // className={
                //   // props.data.assignedTo===""? "error-input1":"select-normal1"
                //   props.data.contactPreference === ""
                //     ? "select-normal1"
                //     : "select-normal1"
                // }
                // className="select-normal1"
                // style={{
                //   position: "absolute",
                //   top: "4px",
                // }}
                // width="100%"
              />
              {/* <AutoComplete1
                 multiple={true}
                 
                 handleChange={props.handleMultipleSelectionDropdown(
                   "contactPreference"
                 )}
                          dashboard="prospect"
                         // handleChange={props.handleOtherDropdown("contactPreference")}
                          options={contactPreference}
                          // value={
                          //   props.data?.contactPreference &&
                          //   contactPreference.filter(
                          //     (data1) => data1.value === props.data.contactPreference
                          //   ).length !==0 ?
                          //   props.data?.contactPreference &&
                          //   contactPreference.filter(
                          //     (data1) => data1.value === props.data.contactPreference
                          //   )[0]
                          //   :
                          //   { label: "select", value: "" }
                          // }
                          value={contactPreference.filter(
                            (data1) =>
                              props.data.contactPreference.indexOf(
                                data1.value
                              ) !== -1
                          )}
                          defaultValue={                           
                            { label: "select", value: "" }                           
                          }                         
                          name="contactPreference"
                /> */}
            </span>
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label class="labelprospect" for="demographics_email_address">
                Email Address
              </label>
              <br />
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="text"
                class={
                  props.data?.contactPreference?.length > 0 &&
                  props.data?.contactPreference?.includes("E")
                    ? props.data?.emailAddress?.length > 0
                      ? props.validator.check(
                          props.data?.emailAddress,
                          "email"
                        ) === true
                        ? "form-control1  w-236px"
                        : "error-inputprospect  w-236px"
                      : "error-inputprospect w-236px"
                    : "form-control1  w-236px"
                }
                id="demographics_email_address"
                name="emailAddress"
                value={props.data.emailAddress}
                maxLength="100"
                onChange={props.handleChange}
                onBlur={props.OnBlurEmailAddr}
              />
              {/* <TextField  name="emailAddress"
                            value={props.data.emailAddress}
                            onChange={props.handleChange} 
                            onBlur={props.OnBlurEmailAddr}                         
                            size="small"
                            error={
                              props.data?.contactPreference?.includes("E")?props.data?.emailAddress?.length>0?
                              props.validator.check(props.data?.emailAddress, "email")===true?
                              false:
                              true:
                              true
                            :false}
                            className="prospectwidth9"
                            label="Email Address" variant="outlined" /> */}
            </span>
            {/* </div> */}
          </div>
          <div class="row ">
            {/* <div class="col-md-12"> */}

            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label class="labelprospect" for="demographics_home_phone">
                Home Phone
                {/* <span class="mandatory-field">*</span> */}
              </label>
              <br />
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="text"
                class={
                  props.data?.contactPreference?.length > 0 &&
                  props.data?.contactPreference?.includes("H")
                    ? props.data.homePhone === "" ||
                      props.data.homePhone?.length < 10
                      ? "error-inputprospect"
                      : "form-control1  w-236px"
                    : "form-control1  w-236px"
                }
                id="demographics_home_phone"
                name="homePhone"
                value={props.data.homePhone}
                onChange={props.handleChange}
                maxLength="14"
              />
              {/* <TextField  name="homePhone"
                            value={props.data.homePhone}
                            onChange={props.handleChange}
                            // maxLength="13"  
                            error={
                              props.data?.contactPreference.includes("H")?(props.data.homePhone === "" || props.data.homePhone?.length<10)?true:false:false}                              
                            
                            size="small"
                            inputProps={{maxLength:13}} 
                            className="prospectwidth9"
                            label="Home Phone" variant="outlined" autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"/> */}
            </span>
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label class="labelprospect" for="demographics_cell_phone">
                Cell Phone
              </label>
              <br />
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="text"
                class={
                  props.data?.contactPreference?.length > 0 &&
                  props.data?.contactPreference.includes("C")
                    ? props.data.cellPhone === "" ||
                      props.data.cellPhone?.length < 10
                      ? "error-inputprospect"
                      : "form-control1  w-236px"
                    : "form-control1  w-236px"
                }
                id="demographics_cell_phone"
                name="cellPhone"
                value={props.data.cellPhone}
                onChange={props.handleChange}
                maxLength="14"
              />
              {/* <TextField name="cellPhone"
                autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                           value={props.data.cellPhone}
                           onChange={props.handleChange}
                           error={
                            props.data?.contactPreference.includes("C")?(props.data.cellPhone === "" || props.data.cellPhone?.length<10)?true:false:false}                              
                            maxLength="13"                                                          
                            size="small"
                            inputProps={{maxLength:13}} 
                            className="prospectwidth9"
                            label="Cell Phone" variant="outlined" /> */}
            </span>
            <span class="col-lg-4  col-md-12 col-sm-12 mb-4 ">
              <label class="labelprospect" for="demographics_best_time2call">
                Best time to call
              </label>
              <br />
              {/* <select 
										class="form-control" 
										id="demographics_best_time2call"
										name="bestTimeToCall" 
                            			value={props.data.bestTimeToCall}
                            			onChange={props.handleChange}
									>
										<option>Select...</option>
										<option>Morning</option>
										<option>Afternoon</option>
										<option>Evening</option>
									</select> */}
              {/* <AutoComplete1
                  handleChange={props.handleOtherDropdown("bestTimeToCall")}
                  options={bestTimeToCall}
                  value={
                    props.data?.bestTimeToCall &&
                    bestTimeToCall.filter(
                      (data1) => data1.value === props.data.bestTimeToCall
                    ).length!==0
                    ?
                    props.data?.bestTimeToCall &&
                    bestTimeToCall.filter(
                      (data1) => data1.value === props.data.bestTimeToCall
                    )[0]
                    :
                    { label: "select", value: "" }
                  }
                  defaultValue={
                    { label: "select", value: "" }
                  }
                  //value={props.data.preferredLang}
                  name="bestTimeToCall"
                  // className={
                  //   // props.data.assignedTo===""? "error-input1":"select-normal1"
                  //   props.data.bestTimeToCall === ""
                  //     ? "select-normal1"
                  //     : "select-normal1"
                  // }
                  className="select-normal1"
                  style={{
                    position: "absolute",
                    top: "4px",
                  }}
                /> */}
              <AutoComplete1
                // label="Best time to call"
                // show={false}
                dashboard="prospect"
                width="236px"
                height="7px !important"
                multiple={true}
                //handleChange={props.handleOtherDropdown("bestTimeToCall")}
                handleChange={props.handleMultipleSelectionDropdown(
                  "bestTimeToCall"
                )}
                options={bestTimeToCall}
                // value={
                //   props.data?.bestTimeToCall &&
                //   bestTimeToCall.filter(
                //     (data1) => data1.value === props.data.bestTimeToCall
                //   ).length!==0
                //   ?
                //   props.data?.bestTimeToCall &&
                //   bestTimeToCall.filter(
                //     (data1) => data1.value === props.data.bestTimeToCall
                //   )[0]
                //   :
                //   { label: "select", value: "" }
                // }
                value={bestTimeToCall.filter(
                  (data1) =>
                    props.data?.bestTimeToCall?.indexOf(data1.value) !== -1
                )}
                defaultValue={{ label: "select", value: "" }}
                name="bestTimeToCall"
              />
            </span>
            {/* </div> */}
          </div>
        </div>
      </div>
    </div>
  );
  //}
};
const mapStateToProps = (state) => {
  return {
    ZipCodes: state.webApp.zipCodes,
  };
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(Demographics);
